import React from 'react';
import { Card } from './common';
import StepIcon from '../../images/health-content/Step.svg';
import rightArrow from '../../images/common/arrow-right-black.svg';
import styled from 'styled-components';

const StepsCard = ({ stepCard }) => {
  return (
    <Card className="w-half p-15 mt-2 health-card flex flex-col">
      <div>
        <div className="flex justify-between w-full">
          <img src={StepIcon} alt="weight-icon" />
          <img src={rightArrow} alt="right-arrow" className="w-6px" />
        </div>
        <h4 className="text-caption-l font-semibold mt-10">Step</h4>
        <h1 className="text-title-l font-bold mt-1">{stepCard?.current}</h1>
        <p className="text-sub text-caption-s">
          Recommended: &nbsp;
          <div className="text-primary font-medium text-caption-s ">
            {stepCard?.goal}
          </div>
        </p>
      </div>
    </Card>
  );
};

export default StepsCard;
